import React from "react";
import { TableCell, Typography, Box } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

// Sortable table header cell
export const SortableHeader = ({ label, tableType, columnKey, currentConfig, align = 'left', handleSort }) => {
  const theme = useTheme();
  const isActive = currentConfig?.key === columnKey;
  const direction = currentConfig?.direction;

  return (
    <TableCell
      onClick={() => handleSort(tableType, columnKey)}
      align={align}
      sx={{
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        transition: 'background-color 0.2s',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, justifyContent: align === 'right' ? 'flex-end' : 'flex-start' }}>
        <Typography variant="inherit" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 0.5 }}>
          <Typography
            variant="caption"
            sx={{
              lineHeight: 1,
              color: isActive && direction === 'asc' ? 'primary.main' : 'text.disabled',
              fontSize: '0.7rem',
            }}
          >
            ▲
          </Typography>
          <Typography
            variant="caption"
            sx={{
              lineHeight: 1,
              color: isActive && direction === 'desc' ? 'primary.main' : 'text.disabled',
              fontSize: '0.7rem',
              mt: -0.25
            }}
          >
            ▼
          </Typography>
        </Box>
      </Box>
    </TableCell>
  );
};

export default SortableHeader;
